import { Controller, FieldValues } from "react-hook-form"
import { IFormControl } from "src/types/index"
import { IPhoneInputProps, PhoneInput } from "./PhoneInput"

type FormPhoneInputProps<T extends FieldValues> = IFormControl<T> & IPhoneInputProps
export const FormPhoneInput = <T extends FieldValues>({ control, name, rules, required, ...props }: FormPhoneInputProps<T>) => {
  return (
    <Controller
      {...{ control, name, rules: { required: { value: required ?? false, message: "This field is required" }, ...rules } }}
      render={({ field: { onChange, value } }) => <PhoneInput {...props} onChange={(value) => onChange(value ?? "")} value={value} />}
    />
  )
}
